module.exports = __webpack_public_path__ + "media/g_m.cfda0539.mp3";